'use client';

import { useEffect, useState } from 'react';

import { Modal } from '@bytel/trilogy-react-ts';

import { CartModal } from '@components/modal/cart-modal';
import { SSIBlock } from '@components/ssi-block';

import { useCart } from '@hooks/use-cart';

export function Header() {
    const { byouCart } = useCart();
    const [shouldShowModal, setShouldShowModal] = useState(false);
    const openModalCart = () => setShouldShowModal(true);
    const [cartModalTitle, setCartModalTitle] = useState('Votre panier est vide');

    useEffect(() => {
        setCartModalTitle(byouCart?.gencode ? 'Détails du panier' : 'Votre panier est vide');
    }, [byouCart]);

    useEffect(() => {
        document.addEventListener('action:panier:click', openModalCart);
        return () => {
            document.removeEventListener('action:panier:click', openModalCart);
        };
    }, []);

    useEffect(() => {
        setTimeout(() => {
            if (!byouCart?.itemsCount) {
                window.postMessage({ shopPanier: { badge: '0' } });
            } else {
                window.postMessage({ shopPanier: { badge: byouCart.itemsCount } });
            }
        }, 100);
    }, [byouCart?.itemsCount]);

    return (
        <>
            <SSIBlock tagId='header' url='/partials/v3/header/shop' />
            <Modal title={cartModalTitle} active={shouldShowModal} onClose={() => setShouldShowModal(false)}>
                <CartModal onClose={() => setShouldShowModal(false)} />
            </Modal>
        </>
    );
}
